import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const GearSpecListState = Immutable.fromJS({
	gearSpecList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1,
	searchWord: ''
});

const gearSpecListReducer = handleActions({
	FIND_GEARSPEC_LIST: (state, { payload }) => {
		return state.merge({
			gearSpecList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
			searchWord: payload.data.searchWord,
		})
	},
	CHANGE_GEARSPEC_ACTIVE_PAGE: (state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	}
}, GearSpecListState);

export default gearSpecListReducer;


// WEBPACK FOOTER //
// ./src/reducers/gearSpecListReducer.js